import React from "react";

function PostList({ follower }) {
  return (
    <div className={`row`}>
      <p>Post List</p>
      <p>Post List</p>
    </div>
  );
}

export default PostList;
